module.exports = __webpack_public_path__ + "images/df321f8.png";